import {createStyles} from '@material-ui/core';
import {defaultFont} from '../../styles/style';

const style = createStyles({
  header: {
    display: 'flex',
    gap: '16px',
    alignItems: 'center',
    marginBottom: '4px',
  },
  header__title: {
    ...defaultFont,
    fontSize: '32px',
  },
  groupsContainer: {
    'display': 'flex',
    'gap': '16px',
    'alignItems': 'start',
    '@media (max-width: 1100px)': {
      flexDirection: 'column',
      alignItems: 'center',
      gap: 0,
    },
  },
  groupsContainer__item: {
    flex: 1,
  },
  dropdown: {
    minWidth: '200px',
  },
});

export default style;
